export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "https://api.nuforce360.com/api",
  useMocks: import.meta.env.VITE_USE_MOCKS === "true",
  /**
   * Where an impersonation session is handed off to. The minted token is
   * passed in the URL fragment, so it never reaches this or any other server.
   */
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL ?? "https://app.nuforce360.com",
};
